<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../helpers/helper";
import VModal from "vue-js-modal";
import Vue from "vue";
import moment from "moment";
import vue2Dropzone from "vue2-dropzone";

//import axios from 'axios';
//import store from '@/state/store'
/**
 * Dashboard Component
 */
Vue.use(VModal);

export default {
  page: {
    title: "Publications",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    vueDropzone: vue2Dropzone,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      moment,
      publication: {
        file: "",
      },
      ans: [],
      isActive: true,
      exporting: false,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      limit: 10,
      perPage: perPage || 10,
      search: "",
      showModal: false,
      status: status == undefined ? "1" : status,
      searchData: debounce(() => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "publication.files.list",
          query: { perPage, status, orderBy, sortBy },
        });
        let id = this.$route.params.id;
        let page = 1;
        this.getPublicationFile({
          page: page,
          perPage: this.perPage,
          search: this.search,
          status: this.status,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          folderId: id,
        });
      }, 500),
      publicationDropzoneOptions: {
        url: process.env.VUE_APP_MIX_URL + "/company/publication",
        thumbnailWidth: 150,
        headers: window.axios.defaults.headers.common,
        maxFiles: 5,
        maxFilesize: 1024, // MB
        maxThumbnailFilesize: 1000000,
        chunking: false,
        acceptedFiles: "application/pdf",
        uploadMultiple: false,
        addRemoveLinks: true,
        success: (response) => {
          if (response.status == "success") {
            // this.$emit('input', this.multiple ? [...this.value?this.value:[], data.file] : [data.file]);
          }
        },
        error: function (file) {
          console.log(file);
        },
      },
    };
  },

  computed: mapGetters("publication", [
    "loading",
    "publicationCount",
    "publicationData",
    "publications",
    "folderName",
    "paginations",
  ]),
  mounted() {
    let orderBy = this.sortDesc ? "desc" : "asc";
    let page = 1;

    let id = this.$route.params.id;
    this.getPublicationFile({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
      folderId: id,
    });
  },
  methods: {
    ...mapActions("publication", [
      "getPublicationFile",
      "getExportCSVData",
      "deletePublication",
      "createPublication",
    ]),
    sortingChanged(ctx) {
      let page = 1;
      let id = this.$route.params.id;
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPublicationFile({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc,
        folderId: id,
      });
      // this.getExportCSVData({
      //   page: page,
      //   search: this.search,
      //   status: this.status,
      //   sortBy: this.sortBy,
      //   orderBy: this.sortDesc,
      // });
    },
    getPublication(page = 1) {
      let id = this.$route.params.id;
      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getPublicationFile({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        folderId: id,
      });
      //   this.getExportCSVData({
      //     page: page,
      //     search: this.search,
      //     status: this.status,
      //     sortBy: this.sortBy,
      //     orderBy: orderBy,
      //  });
    },
    deletePublicationFile(id) {
      if (confirm("Are you sure want to delete?")) {
        this.deletePublication(id).then((res) => {
          if (res) this.getPublicationFile(this.paginations.current_page);
        });
      }
    },
    show() {
      this.$modal.show("hello-world");
    },
    close() {
      this.$modal.hide("hello-world");
      this.isActive = true;
    },
    afterUploadComplete: async function (response) {
      this.isActive = false;

      const data = JSON.parse(response.xhr.response);
      this.ans = data;
    },
    create() {
      let id = this.$route.params.id;
      this.isActive = true;
      var fileData = this.$refs.myVueDropzone.getAcceptedFiles();

      var formData = new FormData();
      fileData.forEach((file) => {
        formData.append("file[]", file);
        formData.append("folder_id", id);
      });
      this.createPublication(formData).then((res) => {
        if (res) this.$modal.hide("hello-world");
        this.isActive = true;
        this.getPublication(this.paginations.current_page);
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-2">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <!-- <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx-category-alt"></i>
                            </span> -->
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">
                {{ folderName.name }}({{ publicationCount }})
              </h4>
            </div>
          </div>
          <div class="page-title-right d-flex">
            <button class="btn btn-success btn-rounded mr-2 add-btn" @click="show">
              <i class="mdi mdi-plus mr-1"></i>Upload File
            </button>
            <!-- <button
              @click="downloadsCSV"
              class="btn btn-primary btn-rounded export-btn"
              :disabled="exporting"
            >
              {{ exporting ? $t("Exporting...") : $t("export_csv") }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-10">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPage"
                      @change="searchData()"
                    >
                      <option value="10" selected>10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- <div class="col-sm-2">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="col-sm-2">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-12">
                <!-- <div class="card">
                  <div class="card-body"> -->
                <div>
                  <modal name="hello-world" style="height: auto !important">
                    <header class="modal-header">
                      <slot name="header"> Publications Files </slot>
                      <i class="mdi mdi-close-thick" @click="close"></i>
                    </header>
                    <section class="modal-body">
                      <slot name="body">
                        <vue-dropzone
                          v-model="publication.file"
                          id="dropzone"
                          ref="myVueDropzone"
                          :use-custom-slot="true"
                          :options="publicationDropzoneOptions"
                          @vdropzone-complete="afterUploadComplete"
                        >
                          <div class="dropzone-custom-content">
                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                            <h4>Drop files here or click to upload PDF.</h4>
                          </div>
                        </vue-dropzone>
                        <br />
                        <div class="text-center">
                          <button
                            v-on:click="create"
                            id="upload"
                            type="submit"
                            class="btn btn-primary"
                            :disabled="isActive"
                          >
                            Upload File
                          </button>
                        </div>
                      </slot>
                      <!-- <div class="text-center mt-4">
                            <button type="button" class="btn btn-primary">
                              Send Files
                            </button>
                          </div> -->
                    </section>
                    <!-- <div class="text-center">
                          <button type="submit" class="btn btn-primary" @click="create">
                            Send Files
                          </button>
                        </div> -->
                  </modal>
                </div>
                <div v-if="publications && publications.length > 0">
                  <div
                    class="dropzone-previews mt-3"
                    id="file-previews"
                    v-for="publication in publications"
                    :key="publication.id"
                  >
                    <div
                      class="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete card"
                    >
                      <div class="p-2">
                        <div class="align-items-center row">
                          <div class="ml-2">
                            <span class="font-size-15 text-muted font-weight-bold">
                              <i class="bx bx-file"></i>
                            </span>
                          </div>
                          <div class="col">
                            <a
                              class="text-muted font-weight-bold"
                              :href="publication.pdf_link"
                              target="_blank"
                              >{{ publication.name }}</a
                            >
                            <br />
                            <small v-if="publication.created_at" style="color: #818491">{{
                              moment(publication.created_at).fromNow()
                            }}</small>
                            <small v-else style="color: #818491">-</small>
                          </div>
                          <div class="mr-3">
                            <button
                              @click="deletePublicationFile(publication.id)"
                              class="btn export-btn"
                            >
                              <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row col-sm-5 offset-sm-7">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                          <pagination
                            :data="paginations"
                            :limit="limit"
                            @pagination-change-page="getPublication"
                          ></pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else><p class="text-center">No files uploaded</p></div>
                <!-- </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.vm--modal {
  height: auto !important;
  top: 80px !important;
}
</style>
